import NotificationTypes from "./notifications.types";

export const addNotification = (notification) => ({
  type: NotificationTypes.ADD_NOTIFICATION,
  payload: notification,
});

export const setNotifications = (notifications) => ({
  type: NotificationTypes.SET_NOTIFICATIONS,
  payload: notifications,
});

export const markAsRead = (notificationIds) => ({
  type: NotificationTypes.MARK_AS_READ,
  payload: notificationIds,
});

export const markAllAsRead = () => ({
  type: NotificationTypes.MARK_ALL_AS_READ,
});

export const clearNotifications = () => ({
  type: NotificationTypes.CLEAR_NOTIFICATIONS,
});

export const setConnectionStatus = (status) => ({
  type: NotificationTypes.SET_CONNECTION_STATUS,
  payload: status,
});

export const setUnreadCount = (count) => ({
  type: NotificationTypes.SET_UNREAD_COUNT,
  payload: count,
});

export const removeNotification = (notificationId) => ({
  type: NotificationTypes.REMOVE_NOTIFICATION,
  payload: notificationId,
});

export const fetchNotificationsStart = () => ({
  type: NotificationTypes.FETCH_NOTIFICATIONS_START,
});

export const fetchNotificationsSuccess = (notifications) => ({
  type: NotificationTypes.FETCH_NOTIFICATIONS_SUCCESS,
  payload: notifications,
});

export const fetchNotificationsFailure = (error) => ({
  type: NotificationTypes.FETCH_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const markAsReadStart = (notificationIds) => ({
  type: NotificationTypes.MARK_AS_READ_START,
  payload: notificationIds,
});

export const markAsReadSuccess = (notificationIds) => ({
  type: NotificationTypes.MARK_AS_READ_SUCCESS,
  payload: notificationIds,
});

export const markAsReadFailure = (error) => ({
  type: NotificationTypes.MARK_AS_READ_FAILURE,
  payload: error,
});
